// import { sortAscending } from "../../../utility/Utility"

const initialState = {
  documentsData: [],
  syncData: [],
  tableLoading: false,
  modalLoading: false,
  chipIndex: 5,
  documentCount: {},
};

const DocumentsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "GET_ALL_DOCUMENTS_DATA":
      return {
        ...state,
        documentsData: payload,
      };
    case "GET_DOCUMENT_BY_ID":
      return {
        ...state,
        documentsData: state.documentsData?.concat(action.payload) || [
          ...action.payload,
        ],
      };
    case "ADD_DOCUMENTS_DATA": {
      return {
        ...state,
        documentsData: state.documentsData?.concat(action.payload) || [
          ...action.payload,
        ],
      };
    }
    case "DELETE_DOCUMENT_DATA": {
      return {
        ...state,
        documentsData: state.documentsData?.filter(({ id }) => id !== payload),
      };
    }
    case "DELETE_ALL_DOCUMENT_DATA": {
      return {
        ...state,
        documentsData: [],
      };
    }

    case "GET_SIMILAR_DOCUMENTS": {
      return {
        ...state,
        documentsData: action.payload,
      };
    }
    case "SET_SYNC_DATA": {
      return {
        ...state,
        syncData: action.payload,
      };
    }
    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload,
      };
    case "SET_MODAL_LOADING":
      return {
        ...state,
        modalLoading: payload,
      };
    case "SET_CHIPS_FILTER":
      return {
        ...state,
        chipIndex: payload,
      };
    case "GET_DOCUMENTS_COUNT":
      return {
        ...state,
        documentCount: payload,
      };
    default:
      return state;
  }
};

export default DocumentsReducer;
